// 9fbef606107a605d69c0edbcd8029e5d
/* eslint-disable max-lines */
import styled, { css } from 'styled-components';
import { applyAspectRatioBoxStyles } from '@tcp/core/src/utils';

export default css`
  background: ${(props) => props.theme.colors.WHITE};
  .product-detail-skeleton-wrapper {
    display: flex;
    flex-direction: column;
  }
  .downloaded-img {
    width: calc(100% - 200px);
    margin-left: 90px;
    margin-right: 90px;
    display: flex;
    justify-content: flex-end;
    img {
      height: 516px;
    }
  }
  .thumbnail-list-wrapper {
    display: none;
  }
  .thumbnail-list {
    margin-bottom: 10px;
    height: 110px;
  }
  .product-main-image {
    height: 436px;
    width: 100%;
    margin-bottom: 40px;
    margin-right: 0;
  }
  .product-overview-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-left: 0;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding-top: 9px;
    }
  }
  .product-title {
    ${(props) => !props.isPDPRedesignEnabled && ` width: 100%;`}

    margin: 0px;
    font-size: 22px;
  }
  .product-price {
    padding-top: 12px;
  }
  .actual-price {
    @media ${(props) => props.theme.mediaQuery.medium} {
      ${(props) =>
        props.isNewPDPEnabled ? `font-size: ${props.theme.typography.fontSizes.fs24};` : ''}
    }
  }

  .promotion-section-pdp-wrapper {
    display: flex;
    column-gap: 12px;
    background: #dbebf8;
    padding: 8px;
    border-radius: 6px;
    margin-bottom: 8px;
    align-items: center;
    height: 33px;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      margin-bottom: 12px;
    }
  }

  .promotion-section-pdp-icon {
    width: 76px;
    display: flex;
    justify-content: center;
    min-width: 76px;
    align-items: center;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      width: 50px;
      min-width: 50px;
    }
  }

  .promotion-section-pdp-text {
    font-size: 14px;
    color: #254f6e;
    font-weight: 600;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      font-size: 11px;
    }
  }

  .promotion-section-pdp-left-arrow {
    margin-left: auto;
  }

  .product-color {
    width: 100%;
    height: 70px;
    margin-bottom: 20px;
  }
  .product-size {
    width: 100%;
    height: 75px;
    margin-top: 18px;
  }
  .clear-button {
    border: none;
    background: transparent;
    padding-top: 2px;
    padding-bottom: 0;
    width: 35px;
  }
  .loyalty-banner-wrapper-new-design {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin: 0px -14px;
      padding: 12px;
      border-radius: 18px;
      background: rgb(255, 255, 255);
      border: none;
    }
  }
  .product-breadcrumb-wrapper {
    min-height: 21px;
    padding-top: 7px;
    padding-bottom: 7px;
  }
  .inline-badge-item {
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      margin-top: 13px;
      padding-bottom: 10px;
    }
  }
  .rating-section-bottom {
    padding-bottom: 10px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-top: 15px;
      padding-top: 12px;
    }

    @media ${(props) => props.theme.mediaQuery.smallOnly},
      ${(props) => props.theme.mediaQuery.large} {
      ${(props) =>
        props.isPDPRedesignEnabled &&
        `
            margin-top: 0;
            padding: 0;
        `}
    }
  }

  .rating-section-bottom.rating-section-bottom-redesigned {
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 23px;
      padding-top: 10px;
      padding-bottom: 10px;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin-left: 0px;
    }
  }

  .product-summary-non-mobile-view-new-design {
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      display: none !important;
    }
  }
  .product-summary-mobile-view-new-design {
    @media ${(props) => props.theme.mediaQuery.medium} {
      display: none !important;
    }
  }

  .hardcoded-plcc-wrapper {
    display: flex;
    flex: 1 1 0%;
    height: 40px;
    padding-top: 7px;
  }
  .hardcoded-plcc.image {
    padding-right: 7px;
    width: 41px;
    height: 26px;
    margin-top: 4px;
  }
  .hardcoded-plcc-anchor {
    flex: 1 1 0%;
    font-family: Nunito;
  }
  .plcc-text-wrapper {
    font-size: 13px;
    line-height: 1;
    margin-top: 5px;
  }
  .hardcoded-plcc-text.text1 {
    font-weight: 900;
  }
  .hardcoded-plcc-text {
    white-space: pre;
  }
  .hardcoded-plcc-text-wrapper {
    position: relative;
  }
  .hardcoded-plcc-text.text2 {
    color: rgb(232, 103, 38);
    font-weight: 700;
  }
  .hardcoded-plcc-text.text3 {
    color: rgb(0, 167, 224);
    font-weight: 900;
  }
  .hardcoded-plcc-text.text4 {
    color: rgb(226, 73, 155);
    font-weight: 900;
  }
  .hardcoded-plcc-text.text5 {
    color: rgb(155, 155, 155);
    font-weight: 900;
    margin-right: 3px;
  }
  .hardcoded-plcc-text.text6 {
    font-size: 14px;
    border: none;
    background: none;
    text-decoration: underline;
    color: rgb(37, 79, 110);
    cursor: pointer;
    right: 0px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      float: left;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      float: right;
    }
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      position: relative;
    }
  }
  .product-price-container .actual-price {
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      font-size: 18px;
    }
  }
  .plcc-list-price {
    text-decoration: line-through;
    font-size: ${(props) => props.theme.typography.fontSizes.fs14};
  }

  .plcc-offer-price {
    color: ${(props) => props.theme.colorPalette.red[500]};
    font-weight: bold;
  }
  .product-brand {
    text-transform: capitalize;
    color: ${(props) => props.theme.colors.TEXT.BRANDGRAY};
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      font-size: 12px;
    }
  }
  .product-detail-main-skeleton-image {
    position: absolute;
    height: 1px;
    width: 1px;
    overflow: hidden;
    visibility: hidden;
  }
  .go-back-container {
    padding-top: 0px !important;
    padding-bottom: 18px;
    ${(props) =>
      props.isPDPRedesignEnabled &&
      `
    padding-bottom:0;
    `}
    button {
      padding-left: 0;
    }

    @media ${(props) => props.theme.mediaQuery.medium} {
      ${(props) =>
        props.isPDPRedesignEnabled &&
        `
    padding-top: 7px !important;
    padding-bottom: 7px !important;
    `}
    }
  }
  .button-go-back {
    border: none;
    display: flex;
    align-items: center;
    background: transparent;
    cursor: pointer;
  }
  .back-button {
    margin-left: 5px;
    color: ${(props) => props.theme.colors.TEXT.BLUE};
  }
  @media ${(props) => props.theme.mediaQuery.medium} {
    .product-detail-skeleton-wrapper {
      display: flex;
      flex-direction: row;
    }
    .thumbnail-list-wrapper {
      display: none;
    }
    .product-main-image {
      height: 436px;
      width: 45%;
      margin-right: 2%;
    }
    .product-overview-wrapper {
      width: 48%;
      display: flex;
      flex-direction: column;
      margin-left: 0;
    }
  }
  .product-skeleton-img {
    min-width: 650px;
  }

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    .product-discription {
      padding-left: 14px;
      padding-right: 14px;
    }
    .original-price {
      .pre {
        font-size: 12px;
      }
    }
    .product-image-wrapper {
      margin-top: ${(props) => (props.isSearchPage ? `10px` : `7px`)};
    }
    .share-fav-icons {
      top: 9px;
    }
    .wishlist-container-wrapper {
      padding-left: 0 !important;
    }
    .product-content-wrapper .wishlist-container-wrapper {
      .fav-icon-wrapper {
        width: 41px;
        height: 41px;
        place-content: center;
      }
      left: 145px;
      width: 41px;
      .clear-button {
        padding: 0 !important;
        width: 26px;
        height: 26px;
      }
    }
  }

  @media ${(props) => props.theme.mediaQuery.medium} {
    .product-detail-skeleton-wrapper {
      padding: unset;
    }
    .product-discription {
      padding-left: 14px;
    }
  }

  @media ${(props) => props.theme.mediaQuery.desktop} {
    .product-detail-skeleton-wrapper {
      display: flex;
      flex-direction: row;
      ${(props) =>
        props.isNewPJPPDPRedesignEnabled ? `max-width:unset;` : `max-width: calc(100% - 232px);`}
    }
  }
  @media ${(props) => props.theme.mediaQuery.desktop} {
    .product-content-wrapper {
      width: ${(props) => (props.isPdpPage ? '100%' : 'calc(100% - 26px)')};
    }
  }
  @media (min-width: 1800px) {
    .product-content-wrapper {
      ${(props) =>
        props.isNewPJPPDPRedesignEnabled
          ? `margin-right:14px!important;margin-left:13px !important;width:100% !important;`
          : ``}
    }
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    .product-detail-skeleton-wrapper {
      display: flex;
      flex-direction: row;
      padding: unset;
    }
    .thumbnail-list-wrapper {
      width: 8%;
      display: flex;
      flex-direction: column;
      margin-right: 5%;
    }
    .product-main-image {
      height: 703px;
      width: 40%;
      margin-right: 5%;
    }
    .product-overview-wrapper {
      width: 602px;
      display: flex;
      flex-direction: column;
      margin: 0;
    }
    .product-image-wrapper {
      margin-right: 0;
    }
    .go-back-container {
      padding-bottom: 36px;
      ${(props) =>
        props.isPDPRedesignEnabled &&
        `
      padding-bottom:0;
      `}
    }
  }

  .color-chips-selector-title,
  .color-chips-selector-title-name {
    font-size: ${(props) => props.theme.fonts.fontSize.listmenu.large}px;
    font-weight: ${(props) => props.theme.fonts.fontWeight.black};
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${(props) => props.theme.colors.PRIMARY.DARK};
    text-transform: uppercase;
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
  }

  .color-chips-selector-title-name {
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-weight: normal;
    margin-left: 6px;
    font-stretch: normal;
  }

  .pdp-size-skeleton {
    margin-right: 12px;
    border-radius: 6px;
    width: 80px;
    height: 42px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: 32px;
      width: 60.4px;
    }
  }

  .pdp-delivery-skeleton {
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 60px;
    }
    @media ${(props) => props.theme.mediaQuery.small} {
      height: 48px;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      height: 64px;
    }
  }

  .size-skeleton {
    @media ${(props) => props.theme.mediaQuery.large} {
      padding-bottom: 28px;
    }
  }

  .pdp-size-fit-skeleton {
    width: 100%;
    height: 120px;
    margin-top: 10px;
  }
  .pdp-redesign-skeleton {
    display: flex;
    flex-direction: column;

    @media ${(props) => props.theme.mediaQuery.medium} {
      margin: 0;
      width: 100%;
    }
  }

  .title-wrapper-new {
    color: #1a1a1a;
    font-family: Nunito;
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 30px; /* 136.364% */
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-bottom: 11px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      margin-bottom: 14px;
    }
  }

  .product-brand-redesign {
    color: #595959;
    font-family: Nunito;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: 12px;
      margin-top: 11px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      font-size: 12px;
    }
  }
  .product-brand-licensed {
    color: rgb(4, 5, 6);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-decoration: underline;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      font-size: 12px;
    }
  }

  .title-redesign {
    color: #1a1a1a;
    font-family: Nunito;
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    @media ${(props) => props.theme.mediaQuery.smallOnly},
      ${(props) => props.theme.mediaQuery.mediumOnly} {
      font-size: 18px;
    }
  }
  .rating-wrapper-new-pdp-redesign {
    padding: 0;
  }
  ${(props) => (props.inheritedStyles ? props.inheritedStyles : '')};
`;

export const BrandName = styled.div`
  height: 16px;
`;

export const ColorSwatchSkeleton = styled.div`
  margin-top: 10px;
  .image-chips-selector-items-list {
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      display: -webkit-box;
      flex-wrap: nowrap;
      white-space: normal;
      width: 100%;
    }
  }
  .image-chips-selector-item {
    width: 54px !important;
    height: 69px !important;
    padding: 0px 10px 8px 0px;
    @media ${(props) => props.theme.mediaQuery.large} {
      overflow: hidden;
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      white-space: normal;
      width: 100%;
    }
  }
  .image-chips-selector-title {
    font-size: ${(props) => props.theme.fonts.fontSize.listmenu.large}px;
    font-weight: ${(props) => props.theme.fonts.fontWeight.black};
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${(props) => props.theme.colors.PRIMARY.DARK};
    text-transform: uppercase;
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    margin-right: 6px;
  }
  .image-chips-selector-title-box {
    display: flex;
    align-items: center;
    padding-top: 12px;
    padding-bottom: 12px;
    margin-top: 20px;
  }
`;

export const SizeSkeleton = styled.div`
  margin-top: 10px;
  .size-selector-items-list {
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      display: -webkit-box;
      flex-wrap: nowrap;
      white-space: normal;
      width: 100%;
    }
  }
  .size-selector-item {
    width: 54px !important;
    height: 69px !important;
    padding: 0px 10px 8px 0px;
    @media ${(props) => props.theme.mediaQuery.large} {
      overflow: hidden;
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      white-space: normal;
      width: 100%;
    }
  }
  .size-selector-title {
    font-size: ${(props) => props.theme.fonts.fontSize.listmenu.large}px;
    font-weight: ${(props) => props.theme.fonts.fontWeight.black};
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${(props) => props.theme.colors.PRIMARY.DARK};
    text-transform: uppercase;
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    margin-right: 6px;
  }
  .size-selector-title-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 12px;
    padding-bottom: 12px;
    height: 14px;
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-top: 20px;
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      padding-top: 14px;
    }
  }
`;

export const PDPTabsSkeleton = styled.div`
  @media ${(props) => props.theme.mediaQuery.large} {
    padding-top: 72px;
    height: 283px;
    margin-right: 13px;
    margin-left: 13px;
    width: calc(100% - 26px);
    margin-bottom: 55px;
  }
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    padding-top: 26px;
    height: 283px;
    margin-right: 15px;
    margin-left: 15px;
    width: calc(100% - 30px);
    margin-bottom: 55px;
  }
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    padding-top: 26px;
    height: 270px;
    margin-left: 12px;
    margin-right: 12px;
    width: calc(100% - 24px);
  }
`;

export const PDPRecommendation = styled.div`
  .hide-skeleton-largeDesktop {
    @media ${(props) => props.theme.mediaQuery.desktop} {
      display: ${(props) => (props.sequence === '2' ? `none` : '')};
    }
  }
  .pdp-recommendations-wrapper {
    position: relative;
    background-color: ${(props) => props.theme.colors.WHITE};
    overflow-x: hidden;
    .pdp-vertical-recomendation {
      @media ${(props) => props.theme.mediaQuery.desktop} {
        display: none;
      }
    }
  }
  .product-detail-section {
    margin: 0;
    padding: 0;
    flex: 1;
    @media ${(props) => props.theme.mediaQuery.medium} {
      .product-description-list {
        padding: 0px;
      }
    }
    @media ${(props) => props.theme.mediaQuery.desktop} {
      margin-right: 30px;
    }
    position: relative;
    background-color: ${(props) => props.theme.colors.WHITE};
  }
  .product-description-list {
    position: relative;
    background-color: ${(props) => props.theme.colors.WHITE};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      border-radius: 18px;
    }
  }
`;

export const PDPATBSkeleton = styled.div`
  margin-top: 10px;
  margin-bottom: 8px;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    margin-top: 27px;
    height: 158px;
    border-radius: 6px;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.12);
    background: ${(props) => props.theme.colors.WHITE};
    margin-bottom: 12px;
  }
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    padding-top: 40px;
  }
  .product-store-option {
    height: 24px;
    margin-top: 12px;
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      margin-top: 24px;
    }
  }
  .store-option {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin: 0 10px 0 10px;
    }
  }
  .atb-or-pickup {
    display: flex;
    margin: 8px 0px;
    padding-bottom: 16px;
    padding-top: 16px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-top: 22px;
    }
  }
  .new-pdp-qty-selector {
    height: 44px;
    margin-right: 10px;
  }
  .decreaseButtonContent {
    height: 1px;
    width: 19px;
    background-color: ${(props) => props.theme.colors.TEXT.GRAY};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 12px;
    }
  }
  .new-pdp-qty-selector .container {
    background-color: ${(props) => props.theme.colors.TEXT.LIGHTGRAY};
    width: 137px;
    height: 42px;
    border: 1px solid ${(props) => props.theme.colors.TEXT.GRAY};
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: 42px;
      width: 107px;
    }
  }
  .decreaseButton.pdpRedesign {
    margin-left: 0px;
  }
  .decreaseButton {
    width: 38px;
    height: 27px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-left: 10px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-left: 0px;
    }
  }
  .selected_qty_value {
    font-size: 16px;
    color: ${(props) => props.theme.colors.TEXT.GRAY};
    font-weight: 700;
  }
  .increaseButton.pdpRedesign {
    margin-right: 4px;
  }
  .increaseButton {
    width: 38px;
    height: 27px;
    position: relative;
    cursor: pointer;
    margin-right: 6px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-right: 1px;
    }
  }
  .horizontalBarVertical {
    transform: rotate(90deg);
  }
  .horizontalBar,
  .horizontalBarVertical {
    width: 16px;
    height: 1px;
    background-color: ${(props) => props.theme.colors.TEXT.GRAY};
    position: absolute;
    top: 50%;
    left: 50%;
  }
  .add-to-bag-button {
    text-align: center;
    width: 100%;
    background-color: ${(props) =>
      props.theme.brandSpecificStyles.PRODUCT_ADD_TO_BAG.BUTTON_BGCOLOR};
    &:hover {
      background-color: ${(props) => props.theme.brandSpecificStyles.BRAND_BASED_BUTTON_HOVER};
    }
    font-size: 14px;
    color: ${(props) => props.theme.colorPalette.white};
    font-weight: ${(props) => props.theme.fonts.fontWeight.extrabold};
    font-stretch: normal;
    line-height: normal;
    font-style: normal;
    letter-spacing: ${(props) => props.theme.typography.letterSpacings.ls1};
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-left: 0px;
      padding: 16px 30px;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      max-height: 42px;
      justify-content: center;
      align-items: center;
      border-radius: 6px;
      padding-top: 12px;
      white-space: pre;
      padding-left: 90px;
      padding-right: 89px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-right: 10px;
      max-height: 42px;
      border-radius: 6px;
      white-space: pre;
    }
  }
`;

export const StyledModuleLoader = styled.div`
  background-color: ${({ theme }) => theme.colors.PRIMARY.LIGHTGRAY};
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    ${(props) =>
      props.aspectRatioObject && applyAspectRatioBoxStyles(props.aspectRatioObject, 'MOBILE', true)}
  }
  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) =>
      props.aspectRatioObject && applyAspectRatioBoxStyles(props.aspectRatioObject, 'TABLET', true)}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) =>
      props.aspectRatioObject &&
      applyAspectRatioBoxStyles(props.aspectRatioObject, 'DESKTOP', true)}
  }
  & .module-loader {
    position: static;
  }
`;
